/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import SalesEntry from './SalesEntry';
import { notify } from '../../Shared/toast';

import {
  mockTables,
  mockOrders,
} from '../../../data/salesData';

function UpdateSalesEntry() {
  // Pick a mock order to simulate editing
  const order = mockOrders[0];

  // Convert to SalesEntry format
  const transformedOrder = {
    id: order.id,
    items: order.finalItems.map((item) => ({
      id: item.productId,
      productId: item.productId,
      name: item.name,
      quantity: item.quantity,
      quantityType: 'pcs',
      price: item.price,
      total: item.price * item.quantity,
      kitchenNotes: '',
      CreatedAt: order.createdAt,
      UpdatedAt: order.updatedAt,
    })),
    customerId: order.customerId,
    tableId: mockTables.find((t) => t.id === order.tableNumber)?.id || '',
    waiterId: order.waiterId,
    notes: order.notes,
  };

  // On demo save, show toast only
  const handleMockSave = () => {
    notify.success('Update Successfully');
  };

  // Optional: simulate send to kitchen
  const handleMockSendToKitchen = () => {
    notify.success('Sent to Kitchen (demo)');
  };

  return (
    <div className="max-w-4xl mx-auto">
      {/* Hard code the date and time for demo purposes */}
      <div className="text-center bg-white text-zinc-950 mt-4">
        <p>
          Created At:
          {new Date(order.createdAt).toLocaleString()}
        </p>
        {/* <p>
          Updated At:
          {new Date(order.updatedAt).toLocaleString()}
        </p> */}
      </div>
      <SalesEntry
        initialOrder={transformedOrder}
        onMockSave={handleMockSave}
        onMockSendToKitchen={handleMockSendToKitchen}
        // createdAt={order.createdAt}
        // updatedAt={order.updatedAt}
      />
    </div>
  );
}

export default UpdateSalesEntry;
